/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Edit_HintInputs */

const en_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click any cell to edit. Click "Save Changes" to commit your edits to the server.`)
};

const fr_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-cliquez sur une cellule pour la modifier. Cliquez sur « Enregistrer les modifications » pour valider vos modifications sur le serveur.`)
};

const de_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelklicken Sie auf eine beliebige Zelle, um sie zu bearbeiten. Klicken Sie auf „Änderungen speichern“, um Ihre Änderungen an den Server zu übertragen.`)
};

const it_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai doppio clic su una cella qualsiasi per modificarla. Fai clic su "Salva modifiche" per salvare le modifiche sul server.`)
};

const ru_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дважды щелкните любую ячейку, чтобы внести изменения. Нажмите «Сохранить изменения», чтобы подтвердить внесенные изменения на сервере.`)
};

const es_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga doble clic en cualquier celda para editarla. Haga clic en "Guardar cambios" para guardar los cambios en el servidor.`)
};

const zh_cn2_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双击任意单元格即可编辑。点击“保存更改”将更改提交到服务器。`)
};

const ja_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集するには、任意のセルをダブルクリックしてください。「変更を保存」をクリックすると、編集内容がサーバーに反映されます。`)
};

const hi_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी भी सेल को संपादित करने के लिए उस पर डबल-क्लिक करें। सर्वर पर अपने बदलावों को सेव करने के लिए "बदलाव सेव करें" पर क्लिक करें।`)
};

const pt_pt2_knp_terms_edit_hint = /** @type {(inputs: Knp_Terms_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique duas vezes em qualquer célula para editar. Clique em "Salvar alterações" para confirmar as alterações no servidor.`)
};

/**
* | output |
* | --- |
* | "Double-click any cell to edit. Click \"Save Changes\" to commit your edits to the server." |
*
* @param {Knp_Terms_Edit_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_edit_hint = /** @type {((inputs?: Knp_Terms_Edit_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Edit_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_edit_hint(inputs)
	if (locale === "de") return de_knp_terms_edit_hint(inputs)
	if (locale === "it") return it_knp_terms_edit_hint(inputs)
	if (locale === "ru") return ru_knp_terms_edit_hint(inputs)
	if (locale === "es") return es_knp_terms_edit_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_edit_hint(inputs)
	if (locale === "ja") return ja_knp_terms_edit_hint(inputs)
	if (locale === "hi") return hi_knp_terms_edit_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_edit_hint(inputs)
	return en_knp_terms_edit_hint(inputs)
});